import { useCallback, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Link from '@material-ui/core/Link';
import Button from 'components/StyledButton/StyledButton';

import logo from '../../logo.png';
import { ReduxState } from '../../redux/types';
import { setFromApi } from '../../redux/user/userSlice';
import api from '../../utils/api';
import snackbar from '../../utils/snackbar';
import { ButtonContainer, CheckboxContainer, FormContainer, Logo, ProgressPlaceholder, StyledProgress, Title } from './styled';

const ConsentsExternalPage = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const userInfo = useSelector((state: ReduxState) => state.user);

    const [consents, setConsents] = useState({
        privacy: userInfo.privacy,
        newsletter: userInfo.newsletter
    });

    const [isLoading, setIsLoading] = useState(false);

    const handleSave = useCallback(() => {
        if (isLoading) return;

        if (!consents.privacy) {
            snackbar.warning(t('pages.consents.need_privacy'));
            return;
        }

        setIsLoading(true);
        api.request('/users/me/consents', 'PUT', consents).then(() => {
            api.request('/users/me').then(profile => {
                dispatch(setFromApi(profile));
                setIsLoading(false);
            });
        });
    }, [consents, dispatch, isLoading, t]);

    const handleConsentChange = useCallback((name, e) => {
        const checked = e.target.checked;
        setConsents(currentConsents => {
            return { ...currentConsents, [name]: checked };
        });
    }, []);

    return (
        <>
            <Logo src={logo} alt='logo' />
            <FormContainer>
                <Title variant='h4'>
                    {t('pages.consents.title')}
                </Title>

                <CheckboxContainer>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={consents.privacy}
                                onChange={(e) => handleConsentChange('privacy', e)}
                                color='primary'
                            />
                        }
                        label={(
                            <Trans i18nKey='pages.consents.privacy'>
                                _<Link href={process.env.REACT_APP_PRIVACY_POLICY} target='_blank'>_</Link>_
                            </Trans>
                        )}
                    />
                </CheckboxContainer>

                <CheckboxContainer>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={consents.newsletter}
                                onChange={(e) => handleConsentChange('newsletter', e)}
                                color='primary'
                            />
                        }
                        label={t('pages.consents.newsletter')}
                    />
                </CheckboxContainer>

                {isLoading ?
                    <StyledProgress /> :
                    <ProgressPlaceholder />
                }

                <ButtonContainer>
                    <Button variant='contained' onClick={handleSave}>
                        {t('pages.consents.confirm')}
                    </Button>
                </ButtonContainer>
            </FormContainer>
        </>
    );
};

export default ConsentsExternalPage;
